import { useOutletContext } from "react-router-dom";
import RMDRLink from "@/components/RMDRLink";
import { TMainPageLayoutV3 } from "../type";
import TOutletContext from "@/cms/types/TOutletContext";
import { metaDataLanguageVersion, outerNameDescriptionLanguageVersion, redirectUrl } from "@/utilities/LanguageVersionSelectorShortcut";


const MNPG065 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG065.rendered: ", props);

    const { siteSettingPayload } = useOutletContext<TOutletContext>();

    const languageVersion = outerNameDescriptionLanguageVersion(props.template?.languageVersions);
    const _redirectUrl = redirectUrl(props.template?.languageVersions);
    const buttonString = metaDataLanguageVersion("buttonString", props.template?.languageVersions);
    const applyToday = metaDataLanguageVersion("applyToday", siteSettingPayload.languageVersions);

    const _buttonString = buttonString||applyToday;

    return (
        <div className="hero-button">
            <RMDRLink
                title={languageVersion?.name}
                hasNavigationDestination={props.template?.hasDestinationNavigation}
                navigationURL={languageVersion?.contentRouteNavigationURL}
                redirectType={props.template?.redirectType}
                redirectUrl={_redirectUrl?.value}
                isShowAlways={true}
                className="theme-btn"
                extraData={{
                    "data-aos-duration":"800",
                    "data-aos":"fade-up",
                    "data-aos-delay":"700"
                }}
            >
                {_buttonString}
                <i className="fa-solid fa-arrow-right-long"></i>
            </RMDRLink>
        </div>
    )
}

export default MNPG065;
